import { BASE_URL } from "../constants";
import { getAuthHeader } from "../utils";

export async function getusersList() {
  try {
    const response = await fetch(BASE_URL + "users-list/", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
    });
    if (!response.ok) {
      throw new Error(JSON.stringify(response));
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating advance: ", error);
    return { type: "error", message: "Error creando anticipo" };
  }
}

export async function getUsersClientList(userID) {
  const queryParams = new URLSearchParams();
  if (userID) {
    queryParams.append("user", userID);
  }
  try {
    const response = await fetch(
      `${BASE_URL}insurance/user-client/?${queryParams.toString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeader(),
        },
      }
    );
    if (!response.ok) {
      throw new Error(JSON.stringify(response));
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating advance: ", error);
    return { type: "error", message: "Error creando anticipo" };
  }
}

export async function saveUserClient({ userID, clientsID }) {
  try {
    const response = await fetch(BASE_URL + "insurance/user-client/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
      body: JSON.stringify({
        user: userID,
        company_client: clientsID,
      }),
    });
    if (!response.ok) {
      throw new Error(JSON.stringify(response));
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating advance: ", error);
    return { type: "error", message: "Error creando anticipo" };
  }
}

/**
 * Get profile picture of current user
 * @author gabrielm
 */
export async function getProfilePicture() {
  try {
    const response = await fetch(BASE_URL + "insurance/profile-picture/", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
    });

    if (!response.ok) {
      throw new Error(JSON.stringify(response));
    }

    /** @type {{ profile_picture: string|null }} */
    const data = await response.json();
    return data.profile_picture;
  } catch (error) {
    console.error("Error fetching profile picture: ", error);
    return null;
  }
}

/**
 * Subir foto de perfil del usuario
 * @author gabrielm
 * @param {object} params
 * @param {File} params.file - The file to upload
 */
export async function uploadProfilePicture({ file }) {
  try {
    const formData = new FormData();
    formData.append("profile_picture", file);

    const response = await fetch(BASE_URL + "insurance/profile-picture/", {
      method: "POST",
      headers: {
        ...getAuthHeader(),
      },
      body: formData,
    });

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.error);
    }

    const data = await response.json();
    return { type: "success", message: data.message };
  } catch (error) {
    console.error("Error uploading profile picture: ", error);
    return { type: "error", message: "Error al subir la foto de perfil" };
  }
}

/**
 * Check if master or call center user can add requirements to case
 * @author gabrielm
 * @param {string | undefined} userId - User ID, or `undefined` to use current user
 * @param {number} clientId - Client ID
 */
export async function canAddRequirementsToCaseCallCenter(userId, clientId) {
  const params = new URLSearchParams({
    user_id: userId,
    client_id: clientId,
  });
  const response = await fetch(
    `${BASE_URL}insurance/can-add-requirements-company-client/?${params.toString()}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
    }
  );

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(
      errorData.message || "Error obteniendo permisos del usuario"
    );
  }

  /** @type {{can_add_requirements: boolean}} */
  const data = await response.json();
  return data;
}

/**
 * Set whether a Call Center or Master user can add requirements to a case
 * @author gabrielm
 * @param {object} params
 * @param {string} params.userId - User ID
 * @param {string} params.clientId - Client ID
 * @param {boolean} params.canAdd - Whether the user can add requirements
 */
export async function setCanAddRequirementsToCaseCallCenter({
  userId,
  clientId,
  canAdd,
}) {
  const response = await fetch(
    BASE_URL + "insurance/can-add-requirements-company-client/",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
      body: JSON.stringify({
        user_id: userId,
        client_id: clientId,
        can_add_requirements: canAdd,
      }),
    }
  );

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(
      errorData.message || "Error actualizando permisos del usuario"
    );
  }

  return { type: "success", message: "Permiso actualizado correctamente" };
}
